// Single source of truth for "why is this control disabled / required" copy shown
// next to alarm controls gated by company settings (require-comment, max-snooze).
// The App sub-issues (ENGS-957 / ENGS-959) mirror these strings verbatim, so treat
// the wording as a cross-team contract. Add a future policy explanation by adding
// one key here.

const pluralizeDays = (n) => `${n} day${Number(n) === 1 ? '' : 's'}`;

export const alarmPolicyCopy = {
    requireComment: () =>
        'Your administrator requires a comment on all alarm actions.',
    silenceDisabled: ({ maxSnoozeDays }) =>
        `Silencing has been disabled by your administrator (max snooze: ${pluralizeDays(maxSnoozeDays)}).`,
    snoozeCapped: ({ maxSnoozeDays }) =>
        `Snoozes longer than ${pluralizeDays(maxSnoozeDays)} have been disabled by your administrator.`,
    snoozeLimitNote: ({ maxSnoozeDays }) =>
        `This site limits snoozes to ${pluralizeDays(maxSnoozeDays)}.`,
};

export function alarmPolicyText(key, context = {}) {
    const entry = alarmPolicyCopy[key];
    return entry ? entry(context) : '';
}
